module.exports = __webpack_public_path__ + "img/BridgingMedicalHardwareCombinations.630ebc27.jpg";